import type {
  AlertConfigQueryParams,
  AlertConfigRequest,
  AlertConfigResponse,
} from "types/api/alertTypes";
import { PageResponse } from "types/pageResponse";

import { makeCancellableAPIRequest } from "./index";

interface AlertNotificationParams {
  source: string;
  toolName: string;
  isWatcherRequired: boolean;
  size?: number;
}

const AlertConfigsAPI = {
  getAllConfigs(queryParams: AlertConfigQueryParams = {}) {
    queryParams = { ...queryParams, isWatcherRequired: true };
    return makeCancellableAPIRequest<PageResponse<AlertConfigResponse>>(
      "GET",
      "/api/alert-configs",
      {
        params: queryParams,
      },
    );
  },
  getAllGlobalConfigs(queryParams: AlertConfigQueryParams = {}) {
    return makeCancellableAPIRequest<PageResponse<AlertConfigResponse>>(
      "GET",
      "/api/alert-configs/global",
      {
        params: queryParams,
      },
    );
  },
  createConfig(data: AlertConfigRequest) {
    return makeCancellableAPIRequest<AlertConfigResponse>(
      "POST",
      "/api/alert-configs",
      {
        data,
      },
    );
  },
  updateConfig(data: AlertConfigRequest & { id: string }) {
    return makeCancellableAPIRequest<AlertConfigResponse>(
      "PUT",
      `/api/alert-configs/global/${data.id}`,
      {
        data,
      },
    );
  },
  getAlertNotificationSource(toolName: string) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/alert-configs/eventwhen/INTEGRATION",
      {
        params: { toolName },
      },
    );
  },
  createAlertNotification(data: AlertConfigRequest) {
    return makeCancellableAPIRequest<AlertConfigResponse>(
      "POST",
      "api/alert-configs",
      {
        data,
      },
    );
  },
  updateAlertNotification(data: AlertConfigRequest, id: string) {
    return makeCancellableAPIRequest<AlertConfigResponse>(
      "PUT",
      `api/alert-configs/${id}`,
      {
        data,
      },
    );
  },
  deleteAlertNotification(id: string) {
    return makeCancellableAPIRequest("DELETE", "api/alert-configs/", {
      params: { id },
    });
  },
  getAlertNotification(toolName: string, pageSize?: number) {
    const params: AlertNotificationParams = {
      source: "INTEGRATION",
      toolName,
      isWatcherRequired: true,
    };
    if (pageSize) {
      params.size = pageSize;
    }
    return makeCancellableAPIRequest<PageResponse<AlertConfigResponse>>(
      "GET",
      "api/alert-configs",
      {
        params,
      },
    );
  },
  getAlertNotificationConfigStatus() {
    return makeCancellableAPIRequest(
      "GET",
      "api/alert-configs/status/INTEGRATION",
    );
  },
};

export default AlertConfigsAPI;
